// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__a9_-P","label":"Radio_label__Z8g2T","checkMark":"Radio_checkMark__1Q4WD","disabled":"Radio_disabled__2TzK8"};